import React, { useState, useEffect } from "react";
import { FaRegBell } from "react-icons/fa";
import { getNotifications } from "api/User.api";
import "./style.scss";

const Notification = () => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const toggleDropdown = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const data = await getNotifications();
        setNotifications(data.data); // Update the notifications state
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <div className="notification-container">
      <div className="notification-icon" onClick={toggleDropdown}>
        <FaRegBell />
      </div>
      {open && (
        <div className="notification-dropdown">
          {notifications.length > 0 ? (
            notifications.map((notification) => (
              <div
                key={notification.id}
                className={`notification-item ${
                  notification.isRead ? "read" : "unread"
                }`}
              >
                <p>{notification.message}</p>
              </div>
            ))
          ) : (
            <p className="no-notifications">No notifications available.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Notification;